export const ICON_NAMES = [
  "waveform", "shield-check", "scan-search", "sparkles",
  "database", "monitor-play", "chart-no-axes-combined", "radio",
  "braces", "blocks", "bot", "rocket",
] as const;

export type IconName = (typeof ICON_NAMES)[number];

export interface AxiomLink {
  id: string;
  name: string;
  url: string;
  description: string;
  icon: IconName;
  color: string;
  order: number;
  createdAt: string;
  updatedAt: string;
}

export type LinkDraft = Pick<AxiomLink, "name" | "url" | "description" | "icon" | "color">;
